import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { SessionService } from '../services/mainServices/session';

interface HasActiveStep {
  activeStep: () => number;
}

export const kycDeactivateGuard: CanDeactivateFn<HasActiveStep> = (component) => {
  const session = inject(SessionService);

  const kyc = session.getCurrentUser()?.kyc;
  if (kyc?.firstName && kyc?.lastName && kyc?.birthDate && kyc?.mobile && kyc?.gender && kyc?.nationlity && kyc?.countryOfResidence && kyc?.spokenLanguages?.length) {
    return true;
  }

  return component.activeStep() >= 1;
};
